// import Cookies from 'js-cookie'

const TokenKey = 'citic-hd'

export function hasValidToken() {
  const token = getToken()
  return isTokenValid(token)
}

export function isTokenValid(token) {
  if (token) {
    const obj = getJwtObj(token)
    const isValid = obj.exp > Date.now() / 1000
    const isSysUser = obj.uid || obj.suid || obj.identify // sysUserID
    return isValid && isSysUser
  }

  return false
}

export function getToken() {
  // return Cookies.get(TokenKey)
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  // return Cookies.set(TokenKey, token)
  localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  // return Cookies.remove(TokenKey)
  localStorage.removeItem(TokenKey)
}

export const getJwtObj = token => {
  if (typeof token === 'object') {
    token = token.length > 0 ? token[0] : ''
  }

  const raw = token.replace(/-/g, '+').replace(/_/g, '/') + '..'
  const rawJson = raw.split('.')[1]
  var obj = token ? JSON.parse(atob(rawJson)) : {}
  return obj
}
